var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIphone24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 1.00086L9 1.0002C7.62 1.00009 6.49991 2.12 6.4998 3.5L6.4984 20.5C6.49829 21.88 7.6182 23.0001 8.9982 23.0002L16.9982 23.0009C18.3782 23.001 19.4983 21.8811 19.4984 20.5011L19.4998 3.50107C19.4999 2.12107 18.38 1.00097 17 1.00086ZM12.9983 22.0005C12.1683 22.0005 11.4983 21.3304 11.4984 20.5004C11.4985 19.6704 12.1685 19.0005 12.9985 19.0005C13.8285 19.0006 14.4985 19.6707 14.4984 20.5007C14.4983 21.3307 13.8283 22.0006 12.9983 22.0005ZM8.49861 18.0002L17.4986 18.0009L17.4998 4.0009L8.49975 4.00016L8.49861 18.0002Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIphone24Px);
export default __webpack_public_path__ + "static/media/phone_iphone_24px.2f02f532ec39486463de123cad01100a.svg";
export { ForwardRef as ReactComponent };